export const MIN_AUTOCOMPLETE_QUERY_LENGTH = 3;
export const DEFAULT_COUNTRY_CODE = "ES";

export const DEFAULT_API_OPTIONS: RequestInit = {
  credentials: "include",
} as const;
